export const API_URL = process.env.NEXT_PUBLIC_API_URI;
export const ASSETS_URL = process.env.NEXT_PUBLIC_ASSETS_URI;
